import React from "react";
import "../HomeMiddle/Middle.css";
// import TestimonialSnippet from "../Testimonials/TestimonialSnippet";
import Statistics from "./Statistics";
import TestimonialSnippet from "../../Testimonials/TestimonialSnippet";
import PropertyRecent from "../HomeMiddle/PropertyRecent";
import Stamp from "../../Assets/Images/AboutUs/zen-stamp.svg";
import Views from "../../Assets/Images/AboutUs/Views.jpeg";

const Middle = () => {
  return (
    <div className="middleContainer">
      <div className="middleIntro">
        <h1>A one-of-a-kind local estate agency.</h1>
        <p>
          With extensive market knowledge and years of experience, we specialise
          in buying, selling, and renting properties. Our expert team provides
          tailored advice, strategic marketing, and skilled negotiations to
          ensure smooth transactions. Whether you're a homeowner, investor, or
          first-time buyer, we offer personalised guidance to help you achieve
          your real estate goals.
        </p>
        <img src={Stamp} alt="Zen Stamp" />
      </div>
      <div className="statistics">
        <Statistics />
      </div>

      <div className="middleGridContainer">
        <div className="middleGridItem image">
          <img src="./buildings-homepage.jpg" alt="building" />
        </div>

        <div className="middleGridItem text">
          <h1>Zen Homes: Expertise & Services</h1>
          <p>
            With extensive market knowledge and years of experience, we
            specialise in buying, selling, and renting properties. Our expert
            team provides tailored advice, strategic marketing, and skilled
            negotiations to ensure smooth transactions. Whether you're a
            homeowner, investor, or first-time buyer, we offer personalised
            guidance to help you achieve your real estate goals.
          </p>
          <button className="middleButton">
            <a href="/about-the-company">Read Our Story</a>
          </button>
        </div>
      </div>
      <div className="ctaHomeContainer">
      <div className="ctaHomeInfo">
            <h1 className="ctaHomeHeading">Thinking of Selling?</h1>
            <p className="ctaHomeText">
              Our goal is to secure the perfect buyer for your property at the
              best price, all while working to your preferred schedule. We
              create a bespoke marketing plan designed around your home and your
              needs—whether that’s a traditional listing, a private viewing
              event, or a more discreet off-market sale.
            </p>
            <div className="ctaHomeButtons">
              <button className="ctaHomeButton1">
                <a href="/book-valuation">Book Valuation</a>
              </button>
            </div>
          </div>
          <div className="ctaHomeImage">
            <img src={Views} alt="building" />
          </div>
         
        </div>

      <h1 className="propertyHeading">Recently Added</h1>
      <PropertyRecent />

      <hr />
      <TestimonialSnippet />
    </div>
  );
};

export default Middle;
